// extracted by mini-css-extract-plugin
export default {"info-box":"DrugsListWrite_info-box__ri-51","text-list-box":"DrugsListWrite_text-list-box__oEWzC"};